import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AlertService, AlertType } from 'src/app/shared/services/alert.service';
import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AdministrationTypeEnum, DilutionEnum, FrequencyEnum, PresentationEnum, TreatmentPeriodEnum, UsageEnum } from 'src/app/shared/enum/prescription.enum';
import { MedicRequiredFieldEnum } from 'src/app/shared/enum/medic-required-field.enum';
import { MedicineAdministrationTypeEnum } from 'src/app/shared/enum/medicine-administration-type.enum';
import { MedicineStruct } from 'src/app/shared/services/structs/pharmacy/medicine.struct';
import { AllergyModel } from 'src/app/shared/services/models/medical-record/allergy.model';
import { MedicineModel } from 'src/app/shared/services/models/pharmacy/medicine.model';
import { ConfirmAllergicPatientModalComponent } from 'src/app/shared/components/confirm-allergic-patient-modal/confirm-allergic-patient-modal.component';
import { KitWithItemsStruct } from 'src/app/shared/services/structs/pharmacy/kit-with-items.struct';
import { KitItemsModalComponent } from 'src/app/shared/components/kit-items-modal/kit-items-modal.component';
import { GetMedicineRequest } from 'src/app/shared/services/requests/pharmacy/get-medicine.request';
import { PrescriptionSolutionStruct } from 'src/app/shared/services/structs/pharmacy/prescription-solution.struct';
import { PrescriptionSolutionMedicineStruct } from 'src/app/shared/services/structs/pharmacy/prescription-solution-medicine.struct';
import { MedicineLinkedKitService } from 'src/app/shared/services/API/pharmacy/medicine-linked-kit.service';
import { TagStruct } from '../../tag/tag.struct';
import { DoseToAdministered } from 'src/app/shared/services/models/pharmacy/dose-to-administered.model';
import { AdministrationLocationEnum } from 'src/app/shared/enum/pharmacy/administration-location.enum';
import { LookupAdministrationLocation } from 'src/app/shared/services/models/pharmacy/lookup-administration-location.model';
import { Subject, Subscription } from 'rxjs';
import { takeUntil, debounceTime } from 'rxjs/operators';
import { calculateTotalDose24h } from 'src/app/shared/services/prescription-dose-calculator.util';
import { DoseToAdministeredEnum } from 'src/app/shared/enum/pharmacy/dose-to-administered.enum';
import { RelationMedicinePresentationTypeAndDoseToAdministered } from 'src/app/shared/services/models/pharmacy/relation-medicine-presentation-type-and-dose-to-administered.model';

const DOSE_UNIT_IDS = {
  frasco: DoseToAdministeredEnum.Frasco,
  ampola: DoseToAdministeredEnum.Ampola,
  ml: DoseToAdministeredEnum.Ml,
  mg: DoseToAdministeredEnum.Mg,
  g: DoseToAdministeredEnum.G,
  mcg: DoseToAdministeredEnum.Mcg,
  doses: DoseToAdministeredEnum.Doses,
  aerossol: DoseToAdministeredEnum.Aerossol,
  comprimido: DoseToAdministeredEnum.Comprimido,
  capsula: DoseToAdministeredEnum.Capsula
};
import { PharmacyConfig } from 'src/app/shared/services/models/pharmacy/pharmacy-config.model';

@Component({
    selector: 'app-medicated-solution-form',
    templateUrl: './medicated-solution-form.component.html',
    styleUrls: ['./medicated-solution-form.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MedicatedSolutionFormComponent implements OnInit, OnDestroy {
  constructor(
    public dialog: MatDialog,
    private alertService: AlertService,
    private formBuilder: FormBuilder,
    private medicineLinkedKitService: MedicineLinkedKitService,
  ) { }

  @Input() blockAllergicPrescription: boolean;
  @Input() isFastTrack: boolean;
  @Input() readOnly: boolean;
  @Input() prescriptionSolutionStruct: PrescriptionSolutionStruct;
  @Input() pharmacyConfig?: PharmacyConfig;
  @Input() listAllergy: AllergyModel[] = [];
  @Input() selectedMedicineList: MedicineStruct[] = [];
  @Input() medicineList: MedicineStruct[] = [];
  @Input() listSubFrequency: any[];
  @Input() frequencyList: any[] = [];
  @Input() presentationList: any[] = [];
  @Input() listDoseToAdministered: DoseToAdministered[] = [];
  @Input() treatmentList: any[] = [];
  @Input() dilutionList: any[] = [];
  @Input() measurementUnitList: any[] = [];
  @Input() usageList: any[] = [];
  @Input() administrationTypeList: any[] = [];
  @Input() lookupMedicalCareResponse: any;
  @Input() medicConfig: any;
  @Input() listMedicine: any;
  @Input() dilutionUnitList: any[] = [];
  @Input() hasNewStandardPrescription: boolean = false;
  @Input() listLookupAdministrationLocation: LookupAdministrationLocation[] = [];
  @Input() listRelationMedicinePresentationTypeAndDoseToAdministered: RelationMedicinePresentationTypeAndDoseToAdministered[] = [];

  @Output() save = new EventEmitter<any>();
  @Output() cancel = new EventEmitter<any>();

  public isLoading: boolean = false;
  public bypassPrescription: boolean = false;
  public isFrequency: boolean = false;
  public isMedicatedSolution: boolean = false;
  public undiluted: boolean = false;
  isLoadingMedicine: boolean = false;

  public idAdministrationType: number;
  public idFrequency: number;
  public idTreatmentPeriod: number;
  public idPresentation: number;
  public idDilution: number;

  public justification: string;

  public frequencyNow: any;

  public administrationTypeListDisplay: any[] = [];

  public administrationTypeOthersEnum: AdministrationTypeEnum = AdministrationTypeEnum.outros;
  public presentationOthersEnum: PresentationEnum = PresentationEnum.outros;
  public dilutionOthersEnum: DilutionEnum = DilutionEnum.outros;
  public dilutionNoDilutionEnum: DilutionEnum = DilutionEnum.semDiluicao;
  public frequencyEnum: typeof FrequencyEnum = FrequencyEnum;
  public administrationInterna: number = AdministrationLocationEnum.InternaInLoco;
  public administrationExterna: number = AdministrationLocationEnum.ExternaCasa;

  public prescriptionModel: FormGroup;
  public selectedMedicine: MedicineStruct;

  public listIdSelectedMedicine: MedicineModel[] = [];
  listKit: KitWithItemsStruct[] = [];
  selectedMedicineLists: any[] = [];
  public listTags: TagStruct[] = [];
  public selectedKitIds: Set<number> = new Set<number>();

  public totalDose24hLabels: (string | null)[] = [];
  public totalEquivalent24hLabels: (string | null)[] = [];

  private destroy$ = new Subject<void>();
  private lineSubscriptions: Subscription[] = [];

  ngOnInit(): void {
    this.populateLookup();

    this.prescriptionModel = this.formBuilder.group({
      listMedicine: this.formBuilder.array([]),
      idAdministrationType: [{ value: null, disabled: this.readOnly }],
      idFrequency: [{ value: null, disabled: this.readOnly }, Validators.required],
      idPresentation: [{ value: null, disabled: this.readOnly }],
      idDilution: [{ value: null, disabled: this.readOnly }],
      idTreatmentPeriod: [{ value: null, disabled: this.readOnly }, Validators.required],
      presentation: [{ value: '', disabled: this.readOnly }],
      dilution: [{ value: '', disabled: this.readOnly }],
      administrationType: [{ value: '', disabled: this.readOnly }],
      observation: [{ value: '', disabled: this.readOnly }],
      idSubFrequency: [{ value: null, disabled: this.readOnly }],
      idDilutionUnit: [{ value: null, disabled: this.readOnly }],
      dilutionQuantity: [{ value: '', disabled: this.readOnly }],
      idLookupAdministrationLocation: [{ value: AdministrationLocationEnum.InternaInLoco, disabled: this.readOnly }, Validators.required],  
    });

    if (this.prescriptionSolutionStruct) {
      this.populateValues();
    } else {
      this.addNextMedicineInput();
      this.addNextMedicineInput();
    }

    this.verifyRequiredFields();

    this.prescriptionModel?.get('idFrequency')?.valueChanges.pipe(
      takeUntil(this.destroy$)
    ).subscribe(() => this.recalculateAllTotals());
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.lineSubscriptions.forEach(s => s.unsubscribe());
  }

  private recalculateLineTotal(index: number): void {
    const lineGroup = (this.prescriptionModel.get('listMedicine') as FormArray).at(index);
    const quantity = lineGroup?.get('quantity')?.value;
    const idFrequency = this.prescriptionModel.get('idFrequency')?.value;
    const idDoseToAdministered: number = lineGroup?.get('idDoseToAdministered')?.value;
    const idMedicine = lineGroup?.get('idMedicine')?.value;
    const idMeasurementUnit = lineGroup?.get('idMeasurementUnit')?.value;

    const result = calculateTotalDose24h(quantity, idFrequency, this.frequencyList);

    if (!result) {
      this.totalDose24hLabels[index] = null;
      this.totalEquivalent24hLabels[index] = null;
      return;
    }

    this.totalDose24hLabels[index] = result.label;

    const medicine = this.medicineList?.find(f => f.medicine.idMedicine === idMedicine);
    if (!medicine) {
      this.totalEquivalent24hLabels[index] = null;
      return;
    }

    const med = medicine.medicine;
    const countMeasurementUnit = med.countMeasurementUnit;
    if (!countMeasurementUnit || countMeasurementUnit <= 0) {
      this.totalEquivalent24hLabels[index] = null;
      return;
    }

    const measurementUnit = this.measurementUnitList?.find(m => m.idMeasurementUnit === idMeasurementUnit);
    const unitNameDisplay = measurementUnit?.measurementUnitName ?? 'Unidade(s)';

    const totalUnits = result.total / countMeasurementUnit;

    if (idDoseToAdministered === DOSE_UNIT_IDS.ml) {
      if (measurementUnit?.idMeasurementUnit === 4) { // idMeasurementUnit=4 é ml
        this.totalEquivalent24hLabels[index] = `(Equivale a ${this.formatNumber(totalUnits)} ${unitNameDisplay})`;
      }
      return;
    }

    if (idDoseToAdministered === DOSE_UNIT_IDS.mg ||
      idDoseToAdministered === DOSE_UNIT_IDS.g ||
      idDoseToAdministered === DOSE_UNIT_IDS.mcg) {
      const unitToMgFactor = this.getUnitToMgFactor(idDoseToAdministered);
      const total24hMg = result.total * unitToMgFactor;
      const units24h = total24hMg / countMeasurementUnit;
      this.totalEquivalent24hLabels[index] = `(Equivale a ${this.formatNumber(units24h)} ${unitNameDisplay})`;
      return;
    }

    if (idDoseToAdministered === DOSE_UNIT_IDS.doses ||
      idDoseToAdministered === DOSE_UNIT_IDS.aerossol ||
      idDoseToAdministered === DOSE_UNIT_IDS.comprimido ||
      idDoseToAdministered === DOSE_UNIT_IDS.capsula) {
      this.totalEquivalent24hLabels[index] = `(Equivale a ${this.formatNumber(totalUnits)} ${unitNameDisplay})`;
      return;
    }

    this.totalEquivalent24hLabels[index] = null;
  }

  private recalculateAllTotals(): void {
    const count = (this.prescriptionModel.get('listMedicine') as FormArray).length;
    for (let i = 0; i < count; i++) {
      this.recalculateLineTotal(i);
    }
  }

  private subscribeToLineQuantity(index: number): void {
    if (this.lineSubscriptions[index]) {
      this.lineSubscriptions[index].unsubscribe();
    }

    const lineGroup = (this.prescriptionModel.get('listMedicine') as FormArray).at(index);

    const sub = lineGroup.valueChanges.pipe(
      debounceTime(300),
      takeUntil(this.destroy$)
    ).subscribe(() => this.recalculateLineTotal(index));

    this.lineSubscriptions[index] = sub;
    this.recalculateLineTotal(index);
  }

  private getUnitToMgFactor(idDoseToAdministered: number): number {
    if (idDoseToAdministered === DOSE_UNIT_IDS.g) return 1000;      // 1 g = 1000 mg
    if (idDoseToAdministered === DOSE_UNIT_IDS.mcg) return 0.001;   // 1 mcg = 0.001 mg
    return 1;                                                         // mg ou outro = 1
  }

  private formatNumber(value: number): string {
    if (value === null || value === undefined || isNaN(value)) return '—';
    return parseFloat(value.toFixed(2)).toLocaleString('pt-BR');
  }

  populateLookup() {
    if (this.frequencyList) {
      this.organizeList();
    }
  }

  createMedicineGroup(): FormGroup {
    let quantityValidators = [];
    let measurementUnitValidators = [];

    if (this.medicConfig && this.medicConfig.listIdRequiredField) {
      if (this.medicConfig.listIdRequiredField.includes(MedicRequiredFieldEnum.prescriptionQuantity)) {
        quantityValidators.push(Validators.required);
      }
      if (this.medicConfig.listIdRequiredField.includes(MedicRequiredFieldEnum.prescriptionMeasurementUnit)) {
        measurementUnitValidators.push(Validators.required);
      }
    }

    return this.formBuilder.group({
      idMedicine: [{ value: null, disabled: this.readOnly }, Validators.required],
      listTags: [[]],
      idMeasurementUnit: [{ value: null, disabled: this.readOnly }, measurementUnitValidators],
      quantity: [{ value: '', disabled: this.readOnly }, quantityValidators],
      idDoseToAdministered: [{ value: null, disabled: this.readOnly }]
    });
  }

  addNextMedicineInput() {
    const formArray = this.prescriptionModel.get('listMedicine') as FormArray;
    const newIndex = formArray.length;
    formArray.push(this.createMedicineGroup());

    const medicines = this.listMedicine || [];
    this.selectedMedicineLists.push([...medicines]);

    this.totalDose24hLabels.push(null);
    this.totalEquivalent24hLabels.push(null);
    this.subscribeToLineQuantity(newIndex);
  }

  populateValues() {
    this.prescriptionSolutionStruct.listSolutionMedicine.forEach((x, index) => {
      (this.prescriptionModel.controls['listMedicine'] as FormArray).push(
        this.formBuilder.group({
          idMedicine: [{ value: x.prescriptionSolutionMedicine.idMedicine, disabled: this.readOnly }, Validators.required],
          listTags: [{ value: x.listTags, disabled: this.readOnly }],
          quantity: [{ value: x.prescriptionSolutionMedicine.quantity ? x.prescriptionSolutionMedicine.quantity.toString() : '', disabled: this.readOnly }],
          idMeasurementUnit: [{ value: x.prescriptionSolutionMedicine.idMeasurementUnit, disabled: this.readOnly }],
          idDoseToAdministered: [{ value: x.prescriptionSolutionMedicine.idDoseToAdministered, disabled: this.readOnly }],
        })
      );

      this.totalDose24hLabels.push(null);
      this.totalEquivalent24hLabels.push(null);
      this.subscribeToLineQuantity(index);
    });

    const arrayLength = (this.prescriptionModel.controls['listMedicine'] as FormArray).length;
    for (let i = 0; i < arrayLength; i++) {
      this.selectedMedicineLists[i] = this.selectedMedicineList;
    }

    this.prescriptionModel.get('idAdministrationType')?.setValue(this.prescriptionSolutionStruct?.prescriptionSolution?.idAdministrationType ?? null);
    this.prescriptionModel.get('idFrequency')?.setValue(this.prescriptionSolutionStruct?.prescriptionSolution?.idFrequency ?? null);
    this.prescriptionModel.get('idPresentation')?.setValue(this.prescriptionSolutionStruct?.prescriptionSolution?.idPresentation ?? null);
    this.prescriptionModel.get('idTreatmentPeriod')?.setValue(this.prescriptionSolutionStruct?.prescriptionSolution?.idTreatmentPeriod ?? null);
    this.prescriptionModel.get('observation')?.setValue(this.prescriptionSolutionStruct?.prescriptionSolution?.observation);
    this.prescriptionModel.get('idDilution')?.setValue(this.prescriptionSolutionStruct?.prescriptionSolution?.idDilution ?? null);
    this.prescriptionModel.get('dilution')?.setValue(this.prescriptionSolutionStruct?.prescriptionSolution?.dilution);
    this.prescriptionModel.get('presentation')?.setValue(this.prescriptionSolutionStruct?.prescriptionSolution?.presentation);
    this.prescriptionModel.get('administrationType')?.setValue(this.prescriptionSolutionStruct?.prescriptionSolution?.administrationType);
    this.prescriptionModel.get('idLookupAdministrationLocation')?.setValue(this.prescriptionSolutionStruct.prescriptionSolution.idLookupAdministrationLocation ?? null);

    if (this.prescriptionSolutionStruct?.prescriptionSolution?.idSubFrequency != null) {
      this.isFrequency = true;
      this.prescriptionModel.get('idSubFrequency')?.setValue(this.prescriptionSolutionStruct?.prescriptionSolution?.idSubFrequency);
    }

    if (this.prescriptionSolutionStruct?.prescriptionSolution?.idDilutionUnit != null) {
      this.undiluted = true;
      this.prescriptionModel.get('idDilutionUnit')?.setValue(this.prescriptionSolutionStruct?.prescriptionSolution?.idDilutionUnit);
      this.prescriptionModel.get('dilutionQuantity')?.setValue(this.prescriptionSolutionStruct?.prescriptionSolution?.dilutionQuantity);
    }

    if (this.readOnly) {
      this.idAdministrationType = this.prescriptionSolutionStruct?.prescriptionSolution?.idAdministrationType;
      this.idFrequency = this.prescriptionSolutionStruct?.prescriptionSolution?.idFrequency;
      this.idTreatmentPeriod = this.prescriptionSolutionStruct?.prescriptionSolution?.idTreatmentPeriod;
    }

    this.justification = this.prescriptionSolutionStruct.prescriptionSolution.justification ?? '';
    this.prescriptionSolutionStruct.listSelectedIdKit.forEach(idKit => this.selectedKitIds.add(idKit));
    this.setSelectedMedicines();
    this.recalculateAllTotals();
  }

  clickCancel() {
    this.cancel.emit();
  }

  onChangeMedicine(event: any, index: number) {
    this.setSelectedMedicines();
    if (!event.value) {
      return;
    }

    this.selectedMedicine = this.medicineList.find(f => f.medicine.idMedicine == event.value);

    (this.prescriptionModel.controls['listMedicine'] as FormArray).at(index).get('listTags')?.setValue(this.selectedMedicine.listTags);
    (this.prescriptionModel.controls['listMedicine'] as FormArray).at(index).get('controlledMedicine')?.setValue(this.selectedMedicine.medicine.controlledMedicine);

    if (this.selectedMedicine.medicine.idMeasurementUnit) {
      (this.prescriptionModel.controls['listMedicine'] as FormArray).at(index).get('idMeasurementUnit')?.setValue(this.selectedMedicine.medicine.idMeasurementUnit);
    } else {
      (this.prescriptionModel.controls['listMedicine'] as FormArray).at(index).get('idMeasurementUnit')?.setValue(null);
    }

    if (this.selectedMedicine.idDoseToAdministered) {
      (this.prescriptionModel.controls['listMedicine'] as FormArray).at(index).get('idDoseToAdministered')?.setValue(this.selectedMedicine.idDoseToAdministered);
    } else {
      (this.prescriptionModel.controls['listMedicine'] as FormArray).at(index).get('idDoseToAdministered')?.setValue(null);
    }

    if (this.selectedMedicine.listAllergy && this.selectedMedicine.listAllergy.length > 0) {
      const allergyDetected = this.selectedMedicine.listAllergy.some(it => this.listAllergy.find(it2 => it2.idAllergy == it));

      if (allergyDetected) {
        const dialogRef = this.dialog.open(ConfirmAllergicPatientModalComponent, {
          data: { blockAllergicPrescription: this.blockAllergicPrescription },
          disableClose: true
        });

        dialogRef.afterClosed().subscribe({
          next: (result) => {
            if (result && result.cancel) {
              (this.prescriptionModel.controls['listMedicine'] as FormArray).at(index).get('idMedicine')?.setValue(null);
              (this.prescriptionModel.controls['listMedicine'] as FormArray).at(index).get('quantity')?.setValue('');
              (this.prescriptionModel.controls['listMedicine'] as FormArray).at(index).get('idMeasurementUnit')?.setValue(null);
              (this.prescriptionModel.controls['listMedicine'] as FormArray).at(index).get('listTags')?.setValue(null);
              (this.prescriptionModel.controls['listMedicine'] as FormArray).at(index).get('idDoseToAdministered')?.setValue(null);
              this.prescriptionModel.get('idAdministrationType')?.setValue(null);
              this.prescriptionModel.get('idAdministrationType')?.enable();
              this.prescriptionModel.get('idDilution')?.setValue(null);
              this.prescriptionModel.get('idPresentation')?.setValue(null);
            } else if (result && !result.cancel && result.justification) {
              this.justification = result.justification;
              this.verifyKits();
            }
          }
        });
      } else {
        this.verifyKits();
      }
    } else {
      this.verifyKits();
    }
  }

  verifyKits() {
    this.isLoadingMedicine = true;

    let getMedicineRequest = new GetMedicineRequest();
    getMedicineRequest.listIdMedicine = this.listIdSelectedMedicine
      .filter(item => item)
      .map(item => Number(item));

    this.searchKits(getMedicineRequest);
  }

  onChangePresentation(event: number) {
    this.idPresentation = event;
    if (this.idPresentation == this.presentationOthersEnum.valueOf()) {
      this.prescriptionModel.get('presentation')?.setValidators(Validators.required);
    } else {
      this.prescriptionModel.get('presentation')?.setValue(null);
      this.prescriptionModel.get('presentation')?.setValidators(Validators.nullValidator);
    }
    this.prescriptionModel.get('presentation')?.updateValueAndValidity();
  }

  onChangeAdministrationType(event: number) {
    this.idAdministrationType = event;
    if (this.idAdministrationType == this.administrationTypeOthersEnum.valueOf()) {
      this.prescriptionModel.get('administrationType')?.setValue(this.selectedMedicine.medicine.medicineAdministrationOther);
      this.prescriptionModel.get('administrationType')?.setValidators(Validators.required);
    } else {
      this.prescriptionModel.get('administrationType')?.setValue(null);
      this.prescriptionModel.get('administrationType')?.setValidators(Validators.nullValidator);
    }
    this.prescriptionModel.get('administrationType')?.updateValueAndValidity();
  }

  onChangeDilution(event: number) {
    this.idDilution = event;

    if (this.idDilution == this.dilutionNoDilutionEnum.valueOf() || this.idDilution == null) {
      this.undiluted = false;
    } else {
      this.undiluted = true;
    }

    if (this.idDilution == this.dilutionOthersEnum.valueOf()) {
      this.prescriptionModel.get('dilution')?.setValidators(Validators.required);
    } else {
      this.prescriptionModel.get('dilution')?.setValue(null);
      this.prescriptionModel.get('dilution')?.setValidators(Validators.nullValidator);
    }

    this.prescriptionModel.get('dilution')?.updateValueAndValidity();
  }

  onKey(value: string, index: number) {
    this.selectedMedicineLists[index] = this.search(value);
  }

  search(value: string) {
    const filter = value.toLowerCase();
    return this.medicineList.filter(option => option.medicine.medicineDescription.toLowerCase().includes(filter));
  }

  onSubmit() {
    this.prescriptionModel.markAllAsTouched();

    if (this.prescriptionModel.invalid) {
      this.alertService.show('Erro', 'Preencha todos os campos obrigatórios!', AlertType.error);
      return;
    }

    this.prescriptionSolutionStruct = new PrescriptionSolutionStruct();

    this.prescriptionModel.get('listMedicine')?.value.forEach((x: any) => {
      const medicine = new PrescriptionSolutionMedicineStruct();
      medicine.prescriptionSolutionMedicine.idMedicine = x.idMedicine;
      medicine.listTags = x.listTags;
      medicine.prescriptionSolutionMedicine.quantity = x.quantity ? parseFloat(x.quantity?.replace(',', '.')) : null;
      medicine.prescriptionSolutionMedicine.idMeasurementUnit = x.idMeasurementUnit ?? null;
      medicine.prescriptionSolutionMedicine.idDoseToAdministered = x.idDoseToAdministered ?? null;
      medicine.medicineName = this.medicineList.find(c => c.medicine.idMedicine == medicine.prescriptionSolutionMedicine.idMedicine)?.medicine.medicineDescription;

      const totalResult = calculateTotalDose24h(
        x.quantity,
        this.prescriptionModel.get('idFrequency')?.value,
        this.frequencyList
      );
      medicine.prescriptionSolutionMedicine.calculatedTotalQuantity = totalResult ? totalResult.total : null;

      this.prescriptionSolutionStruct.listSolutionMedicine.push(medicine);
    });

    this.prescriptionSolutionStruct.prescriptionSolution.idUsage = UsageEnum.interno;
    this.prescriptionSolutionStruct.usage = this.usageList.find(c => c.idUsage == this.prescriptionSolutionStruct.prescriptionSolution.idUsage)?.usageName;
    this.prescriptionSolutionStruct.prescriptionSolution.idAdministrationType =
      this.prescriptionModel.get('idAdministrationType')?.value
        ? this.prescriptionModel.get('idAdministrationType')?.value
        : this.administrationTypeList.find(x => x.idMedicineAdministrationType == MedicineAdministrationTypeEnum.NaoDefinida)?.idMedicineAdministrationType;
    this.prescriptionSolutionStruct.prescriptionSolution.administrationType = this.prescriptionModel.get('administrationType')?.value;
    this.prescriptionSolutionStruct.administrationTypeName = this.prescriptionSolutionStruct.prescriptionSolution.idAdministrationType
      ? this.administrationTypeList.find(x => x.idMedicineAdministrationType == this.prescriptionSolutionStruct.prescriptionSolution.idAdministrationType)?.medicineAdministrationTypeName
      : null;
    this.prescriptionSolutionStruct.prescriptionSolution.idPresentation = this.prescriptionModel.get('idPresentation')?.value ?? null;
    this.prescriptionSolutionStruct.presentationName = this.prescriptionSolutionStruct.prescriptionSolution.idPresentation
      ? this.presentationList.find(c => c.idMedicinePresentationType == this.prescriptionSolutionStruct.prescriptionSolution.idPresentation)?.medicinePresentationTypeName
      : null;
    this.prescriptionSolutionStruct.prescriptionSolution.idLookupAdministrationLocation = this.prescriptionModel.get('idLookupAdministrationLocation')?.value;
    const location = this.listLookupAdministrationLocation.find(c => c.idLookupAdministrationLocation === this.prescriptionModel.get('idLookupAdministrationLocation')?.value);
    this.prescriptionSolutionStruct.lookupAdministrationLocationName = location?.name ?? null;
    this.prescriptionSolutionStruct.prescriptionSolution.presentation = this.prescriptionModel.get('presentation')?.value;
    this.prescriptionSolutionStruct.prescriptionSolution.idFrequency = this.prescriptionModel.get('idFrequency')?.value ?? null;
    this.prescriptionSolutionStruct.frequencyName = this.prescriptionSolutionStruct.prescriptionSolution.idFrequency
      ? this.frequencyList.find(c => c.idFrequency == this.prescriptionSolutionStruct.prescriptionSolution.idFrequency)?.frequencyName
      : null;
    this.prescriptionSolutionStruct.prescriptionSolution.idTreatmentPeriod = this.prescriptionModel.get('idTreatmentPeriod')?.value ?? null;
    this.prescriptionSolutionStruct.treatmentPeriodName = this.prescriptionSolutionStruct.prescriptionSolution.idTreatmentPeriod
      ? this.treatmentList.find(c => c.idTreatmentPeriod == this.prescriptionSolutionStruct.prescriptionSolution.idTreatmentPeriod)?.treatmentPeriodName
      : null;
    this.prescriptionSolutionStruct.prescriptionSolution.idDilution = this.prescriptionModel.get('idDilution')?.value ?? null;
    this.prescriptionSolutionStruct.dilutionName = this.dilutionList.find(c => c.idDilution == this.prescriptionSolutionStruct.prescriptionSolution.idDilution)?.dilutionName ?? null;
    this.prescriptionSolutionStruct.prescriptionSolution.dilution = this.prescriptionModel.get('dilution')?.value;
    this.prescriptionSolutionStruct.prescriptionSolution.observation = this.prescriptionModel.get('observation')?.value;
    this.prescriptionSolutionStruct.prescriptionSolution.idSubFrequency = this.prescriptionModel.get('idSubFrequency')?.value ?? null;
    this.prescriptionSolutionStruct.prescriptionSolution.idDilutionUnit = this.prescriptionModel.get('idDilutionUnit')?.value ?? null;
    this.prescriptionSolutionStruct.prescriptionSolution.dilutionQuantity = this.prescriptionModel.get('dilutionQuantity')?.value;

    if (this.prescriptionSolutionStruct.prescriptionSolution.idSubFrequency != null) {
      const subFrequencyName = this.listSubFrequency.find(x => x.idSubFrequency == this.prescriptionSolutionStruct.prescriptionSolution.idSubFrequency);
      if (subFrequencyName != null) {
        this.prescriptionSolutionStruct.subFrequencyName = subFrequencyName.subFrequencyName;
      }
    }

    if (this.prescriptionSolutionStruct.prescriptionSolution.idDilutionUnit != null) {
      this.prescriptionSolutionStruct.dilutionUnitName = this.dilutionUnitList.find(x => x.idDilutionUnit == this.prescriptionSolutionStruct.prescriptionSolution.idDilutionUnit)?.dilutionUnitName;
    }

    if (this.justification) {
      this.prescriptionSolutionStruct.prescriptionSolution.justification = this.justification;
    }

    this.prescriptionSolutionStruct.listSelectedIdKit = Array.from(this.selectedKitIds.values());
    this.save.emit({ prescriptionSolution: this.prescriptionSolutionStruct, bypassPrescription: this.bypassPrescription });
  }

  verifyRequiredFields() {
    if (!this.medicConfig) return;

    this.medicConfig.listIdRequiredField.forEach((x: number) => {
      if (x == MedicRequiredFieldEnum.prescriptionAdministrationType) {
        this.prescriptionModel.get('idAdministrationType')?.setValidators([Validators.required]);
        this.prescriptionModel.get('idAdministrationType')?.updateValueAndValidity();
      } else if (x == MedicRequiredFieldEnum.prescriptionDilution) {
        this.prescriptionModel.get('idDilution')?.setValidators([Validators.required]);
        this.prescriptionModel.get('idDilution')?.updateValueAndValidity();
      } else if (x == MedicRequiredFieldEnum.prescriptionObservation) {
        this.prescriptionModel.get('observation')?.setValidators([Validators.required]);
        this.prescriptionModel.get('observation')?.updateValueAndValidity();
      }

      const listMedicineArray = this.prescriptionModel.get('listMedicine') as FormArray;
      if (listMedicineArray) {
        listMedicineArray.controls.forEach(control => {
          if (x == MedicRequiredFieldEnum.prescriptionQuantity) {
            control.get('quantity')?.setValidators([Validators.required, Validators.max(32767)]);
            control.get('quantity')?.updateValueAndValidity();
          } else if (x == MedicRequiredFieldEnum.prescriptionMeasurementUnit) {
            control.get('idMeasurementUnit')?.setValidators([Validators.required]);
            control.get('idMeasurementUnit')?.updateValueAndValidity();
          }
        });
      }
    });
  }

  toggleBypassPrescription(event: any) {
    if (event.checked) {
      this.bypassPrescription = true;
      this.selectedMedicineList = this.listMedicine.listMedicineStruct;
    } else {
      this.bypassPrescription = false;
      this.selectedMedicineList = this.listMedicine.listMedicineStruct.filter((x: any) => x.medicine.fastTrack == true);
      const idMedicine: number = this.prescriptionModel.get('idMedicine')?.value;
      const medicine: MedicineStruct = this.listMedicine.listMedicineStruct.find((x: any) => x.medicine.idMedicine == idMedicine);
      if (!this.selectedMedicineList.includes(medicine)) {
        this.prescriptionModel.get('idMedicine')?.setValue(null);
      }
    }
  }

  onChangeFrequency(event: number) {
    if (
      event == this.frequencyEnum.ifNecessary ||
      event == this.frequencyEnum.medicCriteria ||
      event == this.frequencyEnum.continuous
    ) {
      this.isFrequency = true;
      this.prescriptionModel.get('idSubFrequency')?.setValidators([Validators.required]);
      this.prescriptionModel.get('idSubFrequency')?.updateValueAndValidity();
    } else {
      this.isFrequency = false;
      this.prescriptionModel.get('idSubFrequency')?.setValue(null);
      this.prescriptionModel.get('idSubFrequency')?.setValidators([]);
      this.prescriptionModel.get('idSubFrequency')?.updateValueAndValidity();
    }

    if (this.hasNewStandardPrescription) {
      if (event == this.frequencyEnum.now) {
        this.prescriptionModel.get('idTreatmentPeriod')?.setValue(TreatmentPeriodEnum.UmDia);
        this.prescriptionModel.get('idTreatmentPeriod')?.disable();
      } else {
        this.prescriptionModel.get('idTreatmentPeriod')?.enable();
      }

      this.prescriptionModel.get('idTreatmentPeriod')?.updateValueAndValidity();
    }
  }

  organizeList() {
    this.frequencyNow = this.frequencyList.find(x => x.idFrequency == this.frequencyEnum.now);
    this.frequencyList.splice(this.frequencyList.findIndex(x => x.idFrequency == this.frequencyEnum.now), 1);
    this.frequencyList.unshift(this.frequencyNow);
  }

  removeMedicineInput(index: number) {
    if (index != 0) {
      (this.prescriptionModel.controls['listMedicine'] as FormArray).removeAt(index);

      this.totalDose24hLabels.splice(index, 1);
      this.totalEquivalent24hLabels.splice(index, 1);
      if (this.lineSubscriptions[index]) {
        this.lineSubscriptions[index].unsubscribe();
        this.lineSubscriptions.splice(index, 1);
      }
    }
    this.setSelectedMedicines();
  }

  setSelectedMedicines() {
    const medicines = this.prescriptionModel.get('listMedicine')?.['controls'];
    this.listIdSelectedMedicine = medicines?.map((x: any) => x.value.idMedicine) ?? [];

    if (this.prescriptionSolutionStruct) {
      this.verifyKits();
    }
  }

  changeToMedicatedSolution(event: any) {
    this.isMedicatedSolution = !this.isMedicatedSolution;
  }

  searchKits(getMedicineRequest: GetMedicineRequest) {
    this.medicineLinkedKitService.getWithItemsByIdMedicine(getMedicineRequest).pipe(
      takeUntil(this.destroy$)
    ).subscribe({
      next: (response) => {
        this.isLoadingMedicine = false;
        if (response.isError) return;
        this.listKit = response?.listKit?.length > 0 ? response.listKit : [];
      },
      error: (error) => {
        console.error(error);
        this.isLoadingMedicine = false;
      }
    });
  }

  openKit(kit: KitWithItemsStruct) {
    this.dialog.open(KitItemsModalComponent, {
      width: '700px',
      data: { kit }
    });
  }

  isKitSelected(item: KitWithItemsStruct): boolean {
    return this.selectedKitIds.has(item.kit.idKit);
  }

  toggleKitSelection(item: KitWithItemsStruct): void {
    const id = item.kit.idKit;
    if (this.selectedKitIds.has(id)) {
      this.selectedKitIds.delete(id);
    } else {
      this.selectedKitIds.clear();
      this.selectedKitIds.add(id);
    }
  }

  getDoseToAdministeredText(itemFormGroup: AbstractControl): string {
    const idDose = itemFormGroup.get('idDoseToAdministered')?.value;

    if (!idDose) {
      return '';
    }

    const unit = this.listDoseToAdministered?.find(u => u.idDoseToAdministered === idDose);
    return unit?.name ?? '';
  }

  isDoseToAdministeredDisabled(idDoseToAdministered: number, index: number): boolean {
    const listMedicineArray = this.prescriptionModel.get('listMedicine') as FormArray;
    const idMedicine = listMedicineArray.at(index).get('idMedicine')?.value;

    if (!idMedicine) {
      return false;
    }

    const medicineItem = this.medicineList.find(m => m.medicine.idMedicine === idMedicine);
    const presentationType = medicineItem?.medicine?.idMedicinePresentationType;

    if (!presentationType) {
      return false;
    }

    const relationsForPresentation = this.listRelationMedicinePresentationTypeAndDoseToAdministered.filter(
      r => r.idMedicinePresentationType === presentationType
    );

    if (relationsForPresentation.length === 0) {
      return false;
    }

    return !relationsForPresentation.some(r => r.idDoseToAdministered === idDoseToAdministered);
  }
}